<template>
<span v-if="storeAnswer.checked">
  <span class="value-container">
    {{$tr(value, 'label')}}
    <template v-if="value.text_enabled === true && storeAnswer.data.value"> - {{storeAnswer.data.value}}</template>
  </span>
</span>
</template>
<script>
import mixin from './_mixin_display'
import {EmptyAnswer} from './_mixin_display_base';

export default {
  mixins: [mixin],
  props: {
    value: {},
    index: {},
  },
  skipBasic: true,
  computed: {
    storeAnswer(){
      return this.allAnswers.find(a=>a.option_id===this.value.option_id) || EmptyAnswer
    },
  },
  created () {
    this.answer = this.radioAnswerInit(this.field, this.value.option_id, this.index)
  },
  methods: {
    radioAnswerInit(field, option_id, form_result, form) {
      const local_form_result = this.form_result || form_result
      let answer = this.formResultStore.answersByFieldAndOption(field.id, option_id)[0];

      // find the answer defaults in the field
      const field_value = field.datahash.options.values.find(v=>v.option_id === option_id)

      if (!answer) {
        let checked = (field_value.checked === true && !local_form_result.id);
        if (!local_form_result.id){ //setting default value in reality
          checked = field.datahash.options.values.find(opt=>opt.option_id===option_id).checked
        }
        answer = this.initializeAnswer(field, {
          checked,
          option_id: option_id,
          data: {
            placeholder_label: field_value.text_placeholder,
            field_option_label: field_value.label
          }
        }, {form_result})

        this.formResultStore.addAnswer(answer);
      }else{
        if (!local_form_result.id){ //setting default value in reality
          if(!field.datahash.no_defaults){
            answer.checked = field_value.checked
          }
        }
      }

      answer.data.field_option_label = field_value.label
      return answer;
    },
  }
}
</script>